export const colors = {
  black: "#000000",
  grayish_blue: "#343A40",
  light_grey: "rgba(0, 0, 0, 0.54)",
  placeholder_grey: "rgba(0, 0, 0, 0.38)",
  hover_gray: "rgba(0, 0, 0, 0.04)",
  border_gray_color: "rgba(218,218,218,1)",
  range_bg: "#f5f5f5",
  selection_bg: "#EFC9CC",
  white: "white",
  dark_gray: "#1a1a1a",
  legend_text: "rgba(52, 58, 64, 0.7)",
  divider_gray: "#ECECEC",
  background_gray: "#f8f9fa",
  medium_gray: "#808080",
  border_gray: "rgba(128, 128, 128, 1)",
  shadow_black: "rgba(0, 0, 0, 0.25)",
  transparent: "transparent",
  hover_red: "rgba(254, 76, 76, 1)",
  text_gray: "#71767A",
  gradient_gray: "rgba(236, 236, 236, 1)",
  border_hover: "#d0d0d0",
  legend_red: "#ff4444",
  legend_orange: "#ffaa00",
  legend_green: "#00aa44",
  chart_text: "#343A40",
  chart_blue_light: "#AEEFFE",
  chart_blue: "#4FC3F7",
  chart_gray: "#666",
  breakdown_red: "rgba(254, 76, 76, 0.5)",
  breakdown_orange: "rgba(255, 191, 0, 0.5)",
  breakdown_green: "rgba(45, 161, 78, 0.5)",
  breakdown_blue: "#2196F3",
  breakdown_purple: "#9C27B0",
  success_green: "#2DA14E",
  warning_orange: "#FFBF00",
  error_red: "#F44336",
  info_blue: "#2196F3",
  filter_red: "#E6292E",
  bg_grey: "#00000066",
  light_black: "#333",
  black_1: "#4E4E4E",
  toggle_border: "#DDDDDD",
  toggle_selected_bg: "#3498DC",
  download_button_text: "#3B3B3B",
  bar_red: "#D9BCBC",
  bar_gray: "#C9C6C6",
  bar_lavender: "#CAC8E0",
  bar_chilion_pink: "#D9BCBC",
  bar_green: "#93EDAB",
  dashboard_nav_parent_surface: "#E4E4E4",
  dashboard_nav_child_surface: "#DADADA",
  dashboard_nav_nested_divider: "#D0D0D0",
  slateGray: "#757784",
  mistGray: "#B9BAC1",
  skyBlue: "#9CCFF0",
};

export const chartColorMaps = {
  pipelineAgeing: {
    "0-30 days": "#D9BCBC",
    "31-60 days": "#C9C6C6",
    "61-90 days": "#CAC8E0",
    ">90 days": "#CAC8E0",
  } as Record<string, string>,

  weightedPipelineAccountType: {
    EE: "#D9BCBC",
    EN: "#C9C6C6",
    NN: "#CAC8E0",
  } as Record<string, string>,
};
